import { shape, string, number } from 'prop-types';

export default shape({
  id: number.isRequired,
  name: string.isRequired,
  created: string.isRequired,
  type: string.isRequired,
  devices: number.isRequired,
});
